import { useTranslation } from "react-i18next";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import ManagedTextField from "utils/edit/ManagedTextField";
import { ChangeEvent } from "utils/history/Event";
import { asTitle } from "utils/Utils";

import { DecimalField } from "core/field/FieldService";
import { FormFieldExpansionProps } from "core/field/form/FormFieldRow";

export type DecimalFormFieldExpansionProps = FormFieldExpansionProps & {
	field: DecimalField;
};

const DecimalFormFieldExpansion: React.FC<DecimalFormFieldExpansionProps> = (
	props: DecimalFormFieldExpansionProps
) => {
	const { t } = useTranslation();

	function handleValueChange(value: number) {
		const event = new ChangeEvent("/value", props.field.value, value);
		props.onChange(event);
	}

	return (
		<Grid container direction={"column"} alignItems="flex-start">
			<Grid item container alignItems="center">
				<Grid item xs={6} sm={4} md={3} lg={2}>
					<Typography variant="subtitle2">
						{asTitle(t("default"))}
					</Typography>
				</Grid>
				<Grid item xs={6} sm={4} md={3} lg={2}>
					<ManagedTextField
						id={props.field.name}
						type="number"
						fullWidth
						disabled={!props.editable}
						value={props.field.value.toString() ?? ""}
						onUpdate={value =>
							handleValueChange(Number.parseFloat(value))
						}
						variant="standard"
					/>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default DecimalFormFieldExpansion;
